<div class="wrapper">
  <app-appli-side-bar [sidebars]="sidebar" (clickEventIndex)="setFocusIndex($event)"></app-appli-side-bar>
  <div class="top_icon"></div>
  <div class="app_name">{{ appname }}</div>
  <div class="remote_control"></div>
  <div class="datetime">
    {{ now_date_obj.year }}.{{ now_date_obj.month }}.{{ now_date_obj.day }}
    {{ now_date_obj.hhmm }}
  </div>
  <div class="main_content_wrapper">
    <div class="main_content">
      <!--レンタル品一覧-->
      <div *ngIf="rentalIndex == 0">
        <div class="ja">
          <div class="rental_ul">
            <div class="rental_item" *ngFor="let item of rental">
              <div class="rental_name">
                {{ item.name }}
              </div>
              <div class="rental_icon">
                <img [src]="item.icon_url" />
              </div>
            </div>
          </div>
          <div style="font-size:20pt; text-align: center;" *ngIf="lang == 'jpn'">
            貸し出し品はフロント(内線8番)までお問合せ下さい。
          </div>
          <div style="font-size:20pt; text-align: center;" *ngIf="lang == 'eng'">
            Dial '8' for Rental Items.
          </div>
        </div>
      </div>
      <!--bluetoothについて-->
      <div *ngIf="rentalIndex == 1">
        <div class="ja" *ngIf="lang == 'jpn'">
          <p>モーニングコールの設定は客室電話より「*68」をダイヤルして下さい。</p>
        </div>
        <div class="en" *ngIf="lang == 'eng'">
          <p> To set Wake-up Call, Dial ' *68 ' from the Room Telephone.</p>
        </div>
      </div>

    </div>
  </div>
</div>